import DashboardReportEDTable from "./DashboardReportEDTable";

export default DashboardReportEDTable;